import React, { useState, useEffect } from "react";
import TextareaAutosize from "react-textarea-autosize";
import "../styles/components/form.css";
import CloseIcon from "../assets/icons/close-icon.svg";

const WinnerForm = ({ onClose, initialData, mode, onSave }) => {
    const [winnerFullName, setWinnerFullName] = useState(initialData ? initialData.fullName : "");
    const [nameOfThePrize, setNameOfThePrize] = useState(initialData ? initialData.nameOfThePrize : "");
    const [winnerSerialNumber, setWinnerSerialNumber] = useState(initialData ? initialData.serialNumber : "");

    const isFormValid =
        winnerFullName.trim() !== "" &&
        nameOfThePrize.trim() !== "" &&
        winnerSerialNumber !== "";

    const handleSubmit = (e) => {
        e.preventDefault();
        const winnerData = {
            fullName: winnerFullName,
            nameOfThePrize,
            serialNumber: winnerSerialNumber,
            id: initialData ? initialData.id : Date.now(),
        };

        onSave(winnerData);
        onClose();
    };

    useEffect(() => {
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = "auto";
        };
    }, []);

    return (
        <div className="modal-overlay">
            <div className="form">
                <div className="form-header">
                    <h1 className="form-title">
                        {mode === "edit" ? "Редактирование победителя" : "Добавление победителя"}
                    </h1>
                    <button className="close-button" onClick={onClose}>
                        <img src={CloseIcon} alt="Закрыть" />
                    </button>
                </div>
                <form onSubmit={handleSubmit}>
                    <h2 className="form-section-title">Информация победителя</h2>
                    <div className="form-group">
                        <label className="field-label">Полное имя победителя</label>
                        <TextareaAutosize
                            className="textarea-input"
                            placeholder="Введите полное имя победителя"
                            value={winnerFullName}
                            onChange={(e) => setWinnerFullName(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label className="field-label">Приз</label>
                        <TextareaAutosize
                            className="textarea-input"
                            placeholder="Введите название приза"
                            value={nameOfThePrize}
                            onChange={(e) => setNameOfThePrize(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label className="field-label">Серийный номер</label>
                        <input
                            type="number"
                            className="text-input"
                            placeholder="Введите серийный номер"
                            value={winnerSerialNumber}
                            onChange={(e) => setWinnerSerialNumber(e.target.value)}
                        />
                    </div>
                    <div className="form-buttons">
                        <button type="button" className="cancel-button" onClick={onClose}>
                            Отменить
                        </button>
                        <button type="submit" className="save-button" disabled={!isFormValid}>
                            Сохранить
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default WinnerForm;
